function load (component) {
  return () => import(`../views/${component}.vue`)
}

const routes = [{
  path: '/',
  redirect: '/index',
  meta: {
    title: '首页',
    isAuth: false,
  }
},
{
  path: '/index',
  component: load('index/index'),
  meta: {
    title: '首页',
    isAuth: false,
  }
},
{
  path: '/turntable',
  component: load('luckDraw/turntable'),
  meta: {
    title: '转盘',
    isAuth: false,
  }
},
{
  path: '/nineJiuge',
  component: load('luckDraw/nineJiuge'),
  meta: {
    title: '九宫格',
    isAuth: false,
  }
},
{
  path: '/scratchCard',
  component: load('luckDraw/scratchCard'),
  meta: {
    title: '刮刮卡',
    isAuth: false,
  }
},
{
  path: '/cardDraw',
  component: load('luckDraw/cardDraw'),
  meta: {
    title: '翻牌中奖',
    isAuth: false,
  }
},
{
  path: '/iqiyiPurchase',
  component: load('iqiyiPurchase/list'),
  meta: {
    title: '爱奇艺内购',
    isAuth: false,
  }
},
{
  path: '/newUserWelfare',
  component: load('newUserWelfare/index'),
  meta: {
    title: '云南vivo新人福利领取',
    isAuth: false
  }
},
{
  path: '/linkFailed',
  component: load('linkFailed/index'),
  meta: {
    title: 'vivo云南线上商城',
    isAuth: false
  }
},
{
  path: '/wmsLogin',
  component: load('wmsGuide/index'),
  meta: {
    title: '',
    isAuth: false
  }
},
{
  path: '/reset',
  component: load('wmsGuide/resetPassword'),
  meta: {
    title: '重置密码',
    isAuth: false
  }
},
{
  path: '/InvitationCodeList',
  component: load('wmsGuide/InvitationCodeList'),
  meta: {
    title: '邀请码列表',
    isAuth: false
  }
},
{
  path: '/employeePage',
  component: load('employeePage/index'),
  meta: {
    title: '森客灵工',
    isAuth: false
  }
},
{
  path: '/ttBackPage',
  component: load('ttBackPage/index'),
  meta: {
    title: '短剧',
    isAuth: false
  }
}
]

export default routes